export const COLOR_PRESETS = [
  { key: 'tcm-classic',     label: 'TCM Classic',          dots: ['#173f34','#2f7d62','#102f27'],
    vars: { '--green-950':'#102f27','--green-900':'#173f34','--green-700':'#2f7d62','--green-600':'#3b9274','--green-100':'#e6f3ec','--cream':'#f7f1e5','--paper':'#fffdf8','--ink':'#26352f','--muted':'#6f7d76','--border':'#ded5c4','--amber':'#c98024','--red':'#b94040' } },
  { key: 'medical-blue',    label: 'Medical Blue',          dots: ['#1e3a5f','#2563eb','#1e40af'],
    vars: { '--green-950':'#1e3a5f','--green-900':'#1d4ed8','--green-700':'#2563eb','--green-600':'#3b82f6','--green-100':'#dbeafe','--cream':'#f0f7ff','--paper':'#f8fbff','--ink':'#1e293b','--muted':'#64748b','--border':'#cbd5e1','--amber':'#f59e0b','--red':'#ef4444' } },
  { key: 'wellness-green',  label: 'Wellness Green',        dots: ['#166534','#16a34a','#14532d'],
    vars: { '--green-950':'#14532d','--green-900':'#166534','--green-700':'#16a34a','--green-600':'#22c55e','--green-100':'#dcfce7','--cream':'#f0fdf4','--paper':'#f8fff9','--ink':'#14532d','--muted':'#4ade80','--border':'#bbf7d0','--amber':'#eab308','--red':'#dc2626' } },
  { key: 'executive-gold',  label: 'Executive Gold',        dots: ['#92400e','#d97706','#78350f'],
    vars: { '--green-950':'#78350f','--green-900':'#92400e','--green-700':'#b45309','--green-600':'#d97706','--green-100':'#fef3c7','--cream':'#fffbeb','--paper':'#fffef5','--ink':'#3b1c00','--muted':'#92400e','--border':'#fde68a','--amber':'#d97706','--red':'#dc2626' } },
  { key: 'ocean-blue',      label: 'Ocean Blue',            dots: ['#0c4a6e','#0284c7','#082f49'],
    vars: { '--green-950':'#082f49','--green-900':'#0c4a6e','--green-700':'#0284c7','--green-600':'#0ea5e9','--green-100':'#e0f2fe','--cream':'#f0f9ff','--paper':'#f8fcff','--ink':'#0c2340','--muted':'#64748b','--border':'#bae6fd','--amber':'#f59e0b','--red':'#ef4444' } },
  { key: 'sakura',          label: 'Sakura',                dots: ['#9d174d','#ec4899','#831843'],
    vars: { '--green-950':'#831843','--green-900':'#9d174d','--green-700':'#db2777','--green-600':'#ec4899','--green-100':'#fce7f3','--cream':'#fdf2f8','--paper':'#fff8fc','--ink':'#500724','--muted':'#9d174d','--border':'#fbcfe8','--amber':'#f59e0b','--red':'#dc2626' } },
  { key: 'sunset',          label: 'Sunset',                dots: ['#9a3412','#ea580c','#7c2d12'],
    vars: { '--green-950':'#7c2d12','--green-900':'#9a3412','--green-700':'#c2410c','--green-600':'#ea580c','--green-100':'#ffedd5','--cream':'#fff7ed','--paper':'#fffbf5','--ink':'#3b0a00','--muted':'#92400e','--border':'#fed7aa','--amber':'#d97706','--red':'#dc2626' } },
  { key: 'earth',           label: 'Earth',                 dots: ['#365314','#65a30d','#1a2e05'],
    vars: { '--green-950':'#1a2e05','--green-900':'#365314','--green-700':'#4d7c0f','--green-600':'#65a30d','--green-100':'#ecfccb','--cream':'#f7fee7','--paper':'#fefff5','--ink':'#1a2e05','--muted':'#4a7c59','--border':'#d9f99d','--amber':'#ca8a04','--red':'#dc2626' } },
  { key: 'dark-pro',        label: 'Dark Professional',     dots: ['#1f2937','#374151','#111827'],
    vars: { '--green-950':'#111827','--green-900':'#1f2937','--green-700':'#374151','--green-600':'#4b5563','--green-100':'#f3f4f6','--cream':'#f9fafb','--paper':'#ffffff','--ink':'#111827','--muted':'#6b7280','--border':'#d1d5db','--amber':'#d97706','--red':'#ef4444' } },
  { key: 'clean-white',     label: 'Clean White',           dots: ['#e2e8f0','#64748b','#f8fafc'],
    vars: { '--green-950':'#1e293b','--green-900':'#334155','--green-700':'#475569','--green-600':'#64748b','--green-100':'#f1f5f9','--cream':'#f8fafc','--paper':'#ffffff','--ink':'#1e293b','--muted':'#64748b','--border':'#e2e8f0','--amber':'#f59e0b','--red':'#ef4444' } },
];

export const TEMPLATE_PRESETS = [
  { key: 'tcm',        label: 'TCM Clinic',            sub: 'Akupunktur & herbal',  preset: 'tcm-classic',    wallpaper: 'daun',         font: 'DM+Sans' },
  { key: 'medical',    label: 'Medical Clinic',         sub: 'Klinik umum modern',   preset: 'medical-blue',   wallpaper: 'medical-grid', font: 'Inter' },
  { key: 'wellness',   label: 'Wellness Spa',           sub: 'Holistik & relaksasi', preset: 'wellness-green', wallpaper: 'bambu',        font: 'Poppins' },
  { key: 'beauty',     label: 'Beauty Center',          sub: 'Estetik & perawatan',  preset: 'sakura',         wallpaper: 'soft-blobs',   font: 'Noto+Sans' },
  { key: 'rehab',      label: 'Rehabilitation Center',  sub: 'Fisioterapi & rehab',  preset: 'ocean-blue',     wallpaper: 'corporate',    font: 'Roboto' },
  { key: 'corporate',  label: 'Corporate Clinic',       sub: 'Profesional & formal', preset: 'dark-pro',       wallpaper: 'tidak-ada',    font: 'Inter' },
];

export const WALLPAPER_OPTIONS = [
  { value: 'tidak-ada',    label: 'Tidak ada' },
  { value: 'bambu',        label: 'Bambu' },
  { value: 'daun',         label: 'Daun' },
  { value: 'medical-grid', label: 'Medical Grid' },
  { value: 'corporate',    label: 'Corporate' },
  { value: 'soft-blobs',   label: 'Soft Blobs' },
  { value: 'abstrak',      label: 'Abstrak' },
];

export const FONT_OPTIONS = [
  { value: 'DM+Sans',   label: 'DM Sans (default)' },
  { value: 'Inter',     label: 'Inter' },
  { value: 'Roboto',    label: 'Roboto' },
  { value: 'Open+Sans', label: 'Open Sans' },
  { value: 'Noto+Sans', label: 'Noto Sans' },
  { value: 'Poppins',   label: 'Poppins' },
];

const WALLPAPER_CSS = {
  'bambu':        'repeating-linear-gradient(90deg, rgba(0,0,0,.03) 0 1px, transparent 1px 28px), repeating-linear-gradient(180deg, rgba(0,0,0,.03) 0 1px, transparent 1px 28px)',
  'daun':         'radial-gradient(ellipse at 20% 50%, rgba(47,125,98,.06) 0%, transparent 60%), radial-gradient(ellipse at 80% 20%, rgba(59,146,116,.05) 0%, transparent 50%)',
  'medical-grid': 'repeating-linear-gradient(0deg, transparent, transparent 39px, rgba(37,99,235,.07) 39px, rgba(37,99,235,.07) 40px), repeating-linear-gradient(90deg, transparent, transparent 39px, rgba(37,99,235,.07) 39px, rgba(37,99,235,.07) 40px)',
  'corporate':    'repeating-linear-gradient(45deg, rgba(0,0,0,.02) 0 1px, transparent 1px 40px), repeating-linear-gradient(-45deg, rgba(0,0,0,.02) 0 1px, transparent 1px 40px)',
  'soft-blobs':   'radial-gradient(ellipse at 10% 10%, rgba(236,72,153,.07) 0%, transparent 50%), radial-gradient(ellipse at 90% 80%, rgba(168,85,247,.06) 0%, transparent 50%)',
  'abstrak':      'conic-gradient(from 0deg at 50% 50%, rgba(0,0,0,.02), rgba(0,0,0,.04), rgba(0,0,0,.02))',
  'tidak-ada':    'none',
};

let _fontLink = null;

export function applyAppearance(app = {}) {
  const root = document.documentElement;

  // 1. Color preset
  const preset = COLOR_PRESETS.find(p => p.key === app.preset);
  if (preset) {
    Object.entries(preset.vars).forEach(([k, v]) => root.style.setProperty(k, v));
  }

  // 2. Sidebar override
  if (app.sidebar_color) root.style.setProperty('--green-900', app.sidebar_color);

  // 3. Font
  const fontKey = app.font || 'DM+Sans';
  const fontFamily = fontKey.replace(/\+/g, ' ');
  if (fontKey !== 'DM+Sans') {
    if (_fontLink) _fontLink.remove();
    _fontLink = document.createElement('link');
    _fontLink.rel = 'stylesheet';
    _fontLink.href = `https://fonts.googleapis.com/css2?family=${fontKey}:wght@400;500;600;700&display=swap`;
    document.head.appendChild(_fontLink);
  }
  root.style.setProperty('font-family', `'${fontFamily}', system-ui, sans-serif`);

  // 4. Wallpaper
  const bg = WALLPAPER_CSS[app.wallpaper] || 'none';
  root.style.setProperty('--wallpaper-bg', bg);

  // 5. Density
  document.body.classList.remove('density-compact', 'density-comfortable');
  if (app.density === 'compact')      document.body.classList.add('density-compact');
  if (app.density === 'comfortable')  document.body.classList.add('density-comfortable');

  // 6. Animation
  document.body.classList.remove('anim-minimal', 'anim-off');
  if (app.animation === 'minimal')    document.body.classList.add('anim-minimal');
  if (app.animation === 'off')        document.body.classList.add('anim-off');
}
